import Typography from '@cobliteam/ui/components/Typography';
import AddFace from '@cobliteam/ui-business/icons/face-id/add-face.svg?react';

interface DriverFaceIdHeaderProps {
  filesCount?: number;
  filesMax?: number;
}

const DriverFaceIdHeader = ({ filesMax, filesCount = 0 }: DriverFaceIdHeaderProps) => {
  return (
    <div className='flex items-center gap-4'>
      <AddFace className='size-6 text-primary' />
      <Typography variant='text-md-semibold'>Fotos para reconhecimento facial {filesMax && `(${filesCount}/${filesMax})`}</Typography>
    </div>
  );
};

export default DriverFaceIdHeader;
